import { Box, Typography } from '@mui/material';
import { useCurrentUser } from '@lingaai/user-management';

export function PreferencesPanel() {
  const { data: user } = useCurrentUser();

  if (!user) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Preferences
      </Typography>
      <Typography color="text.secondary">User preferences will be added here.</Typography>
    </Box>
  );
}
